import * as _ from 'lodash';

const ORDINE_DEL_GIORNO = 3;

function searchSessionParams({groupId, ownerId, roleType, sessionId, toString = false}) {

  const params = {
    groupId: groupId ,
    ownerId: ownerId ,
    queryRoleType: roleType,
    typeTags: [
      {
        "type": "ID",
        "tags": [
          sessionId
        ]
      }
    ]
  }

  console.log(JSON.stringify(params))
  return toString ?
    JSON.stringify(params) :
    params
}

function searchSessionParamsTypeTags({groupId, ownerId, roleType, typeTags, fromDate, toDate, toString = false,term, size, sortProperties, direction}) {

  const params = {
    groupId: groupId ,
    ownerId: ownerId ,
    queryRoleType: roleType,
    typeTags: typeTags,
  }
  if(fromDate)
    params.fromDate = fromDate;
  if(toDate)
    params.toDate = toDate;
  if(term)
    params.term = term;
  if(size)
    params.size = size;

  if(sortProperties)
    params.sortProperties = sortProperties;

  if(direction)
    params.direction = direction;
  
  //  "fromDate": "2021-11-06T09:11:18.584Z",
  // "toDate": "2021-11-06T09:11:18.584Z",
  // "page": 0,
  // "size": 0,
  // "sortProperties": [
  //   "string"
  // ],
  // "direction": "ASC or DESC"

  console.log(JSON.stringify(params))
  return toString ?
    JSON.stringify(params) :
    params
}

function prepareTypeTags(timeNotes) {
  const speakers = new Set();
  const ordineDelGiorno = new Set();
  const faseSeduta = new Set();
  timeNotes.forEach(t => {
    if (t.speaker) {
      const splitted = t.speaker.split(' ');
      splitted.forEach(s => {
        speakers.add(s);
      })
    }
    if (!_.isEmpty(t.fase)) {
      faseSeduta.add(t.fase.name);
    }
    if (t.evento.id === 3) {
      ordineDelGiorno.add(t.testo);
    }
  })

  return {
    speakers: [...speakers],
    faseSeduta: [...faseSeduta],
    ordineDelGiorno: [...ordineDelGiorno]
  }
}

function prepareSessionRecorder(session, typeTags) {
  console.log(typeTags)
  console.log(session.typeTags);
  const typeTagsId = session.typeTags.find(tt => tt.type === 'ID');
  const typeTagsNomeSessione = session.typeTags.find(tt => tt.type === 'NUMEROSESSIONE');
  let newTypeTags = [typeTagsId];
  if (typeTagsNomeSessione) {
    newTypeTags = [...newTypeTags, typeTagsNomeSessione];
  }
  if (typeTags.speakers.length) {
    newTypeTags = [...newTypeTags, {type: 'ORATORE', tags: typeTags.speakers}]
  }
  if (typeTags.ordineDelGiorno.length) {
    newTypeTags = [...newTypeTags, {type: 'ODG', tags: typeTags.ordineDelGiorno}]
  }
  if (typeTags.faseSeduta.length) {
    newTypeTags = [...newTypeTags, {type: 'FASESEDUTA', tags: typeTags.faseSeduta}]
  }

  console.log(newTypeTags);
  const sessionDto = {
    ...session,
    typeTags: newTypeTags,
    itemId: session.id
  };
  delete sessionDto.id;
  console.log('sessionDto: ', sessionDto);
  return sessionDto;
}

export const sessionManageUtils = {
  searchSessionParams,
  prepareTypeTags,
  prepareSessionRecorder,
  searchSessionParamsTypeTags
}
